module.exports = __webpack_public_path__ + "static/media/wiz_sailboat_active_ic.cbed006f.svg";